import {
  LOAD_LOGIN, SHOW_LOCK, LOGIN_SUCCESS, LOGIN_ERROR, LOGOUT
} from '../actions/LoginAction'

// The auth reducer. The starting state sets authentication
// based on a token being in local storage. In a real app,
// we would also want a util to check if the token is expired.
const auth = (state = {
    profile: '',
    isAuthenticated: false
  }, action) => {

  switch (action.type) {
    case SHOW_LOCK:
      return state
    case LOAD_LOGIN:
      return { ...state,
        profile: action.profile,
        isAuthenticated: action.token?true:false
      }
    case LOGIN_SUCCESS:
      return { ...state,
        isAuthenticated: true
      }
    case LOGIN_ERROR:
      return { ...state,
        errorMessage: action.err
      }
    case LOGOUT:
      return { ...state,
        profile: '',
        isAuthenticated: false
      }
    default:
      return state
  }
}

export default auth;



// WEBPACK FOOTER //
// ./src/reducers/login.js